import { useMutation } from "@apollo/client";
import { RESET_PASSWORD } from "../../graphql";
import {
  ResetPasswordMutation,
  ResetPasswordMutationVariables,
} from "../../types";

export const useResetPassword = () => {
  return useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(
    RESET_PASSWORD
  );
};
